import React, { useEffect, useState } from 'react';
import { getEnvVariable } from '../../../modules/environmentalList';
import { useParams } from 'react-router-dom';

// Dynamically import the Preview component using Module Federation
// const Preview = lazy(() => import('previewApp/PreviewApp'));

/**
 * Renders the Preview component.
 * 
 * @returns The rendered Preview component.
 * 
 * @date 12/26/2024
 */
const DashboardFlowIntegration = () => {
    const { view, id } = useParams();
    // Retrieve URL parameters using useParams hook
    // Construct the URL for the iframe source  
    const [iframeSrc, setIframeSrc] = useState(`${getEnvVariable('DashBoardViewer')}`);

    // Set iframe path based on id and version params
    useEffect(() => {
        const baseUrl = getEnvVariable('DashBoardViewer');
        if (view && id) {
            setIframeSrc(`${baseUrl}${view}/${id}`);
        } else {
            setIframeSrc(baseUrl);
        }
    }, [id, view]);


    return (
        <div style={{ height: window.innerHeight - 40 }}>
            <iframe
                src={iframeSrc}
                title="Preview"
                className="preview-iframe"
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );

    // const dispatch = useDispatch();
    // const flowData = useSelector((state) => state.form.flowData);

    // useEffect(() => {
    //     if (flowid) {
    //         let url = API_URLS.FETCH_PREVIEW.replace('{flowid}', flowid);
    //         post(url, {}).then((res) => {
    //             dispatch(setFlowData(res));
    //         });
    //     }
    // }, [flowid]);

    // if (flowData && Object.keys(flowData).length > 0) {
    //     console.log('Flow Data in Host:', flowData);
    //     return (
    //         // Render the dynamically imported Preview component with flowId as a prop
    //         <Preview />
    //     );
    // }
    // else return <></>
}

export default DashboardFlowIntegration;